export { DMS_MODULE, NAME as ZNAME } from '../constants';
export const CRUMB_LABEL_KEY = 'edtZakazkalist';
export const NAME = 'ZakazkaList';
export const RPZV_LOG = 'RpzvLog';
export const POLOZKY = 'Polozky';
export const ZAKAZKA_LIST_FILES = 'ZakazkaListFiles';
export const PENDING_JOB_LIST = 'PendingJoblist';
export const SAVE_JOBLIST = 'Save';
export const LOAD_JOBLIST = 'Load';
export const PROFORMA_NAVINGATION = 'Proforma Navigation';
export const BILLING_NAVIGATION = 'Billing Navigation'
export const DEPENDENT_TABLES = <const>[
	POLOZKY,
	RPZV_LOG,
	ZAKAZKA_LIST_FILES,
	PENDING_JOB_LIST,
];

export enum RPZV_STATUS {
	ODESLANO_OK = 1,
	ODESLANO_CHYBA = 2,
	ODESLANO_PHOTO = 3,
	NEODESLANO_DMS = 9,
}
export enum REMARK_STATUS {
	COMPLAINT = 1,
	INSTRUCTION = 2,
	SERVICE = 3,
	SAFETY = 9,
}

export enum JOB_LIST_STATUS {
	APPROVED = 1,
	REJECTED = 0,
}

export const REPAIR_INSTRUCTION = 'REPAIR_INSTRUCTION';
export const SALARY_AMOUNT = 'SALARY_AMOUNT';
export const EST_COST_PART = 'EST_COST_PART';
export const MAIN_PART_NAME = 'MAIN_PART_NAME';
export const EXECUTED = 'EXECUTED';
export const SOURCE_TYPE = 'SOURCE_TYPE';
export const REMARK_TYPE = 'REMARK_TYPE';

export const POLOZKY_COLS = {
	REPAIR_INSTRUCTION,
	SALARY_AMOUNT,
	EST_COST_PART,
	MAIN_PART_NAME,
	EXECUTED,
	SOURCE_TYPE,
	REMARK_TYPE,
};
